<div>
  <h1 mat-dialog-title>Inspección - Cobot</h1>
  <button mat-icon-button class="close-button" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>

  <!-- Header-->
  <div mat-dialog-content>
    <mat-card-header>
      <mat-card-title class="tw-text-black">Cobot</mat-card-title>
      <!-- <mat-card-subtitle>Info</mat-card-subtitle> -->
    </mat-card-header>

    <mat-card-content>
      <div class="tw-flex tw-flex-row tw-gap-4" *ngIf="stepsAvailables">
        <div>
          <p>RunId: {{ steps[currentStep].cobotRunId }}</p>
        </div>
        <div>
          <p>
            Fecha: {{ steps[currentStep].cobotCreatedAt | date: "dd/MM/yyyy" }}
          </p>
        </div>
      </div>

      <ng-container *ngIf="stepsAvailables">
        <mat-stepper [linear]="true" [selectedIndex]="currentStep">
          <mat-step
            *ngFor="let step of steps; let i = index"
            [label]="'Cav ' + step.cavity"
          >
          </mat-step>
        </mat-stepper>

        <ng-container *ngIf="steps[currentStep] as current">
          <ng-container *ngTemplateOutlet="step; context: { cavity: current }">
          </ng-container>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </div>

  <mat-dialog-actions align="end">
    <button
      mat-raised-button
      color="primary"
      *ngIf="currentStep > 0"
      (click)="previousStep()"
    >
      Anterior
    </button>

    <button
      mat-raised-button
      color="primary"
      *ngIf="currentStep < steps.length - 1"
      (click)="nextStep()"
    >
      Siguiente
    </button>

    <button
      mat-raised-button
      class="tw-bg-green-600"
      *ngIf="currentStep === steps.length - 1"
      (click)="onClickInspection()"
    >
      Finalizar
    </button>
  </mat-dialog-actions>
</div>

<ng-template #step let-cavity="cavity">
  <div
    class="
      tw-w-full tw-mx-auto tw-justify-items-center tw-grid tw-grid-cols-1
      lg:tw-grid-cols-2
      xl:tw-grid-cols-3
      tw-gap-3
    "
  >
    <ng-container *ngFor="let item of cavity.items; let index = index">
      <div
        class="tw-rounded-lg tw-p-0 tw-w-fit tw-border-[8px]"
        appearance="outlined"
        [ngClass]="{
          'tw-border-green-400': item.setManuallyError === false,
          'tw-border-red-400': item.setManuallyError === true,
          'tw-border-gray-400': item.setManuallyError === null
        }"
        (click)="setManuallyImgStatus(item)"
      >
        <div class="tw-relative tw-h-full">
          <img
            [src]="
              item.imageUrl
                ? item.imageUrl
                : 'https://placehold.co/600x400?text=Image+not+provided'
            "
            alt="Item Cobot Image"
            class="
              tw-mx-auto
              tw-mb-0
              tw-h-full
              tw-object-contain
              tw-rounded-sm
              tw-min-w-64
              tw-min-h-56
              tw-aspect-[1600/1200]
            "
          />
          <div
            class="
              tw-absolute
              tw-z-10
              tw-left-0
              tw-right-0
              tw-bg-black/75
              tw-flex
              tw-justify-center
              tw-items-start
              tw-gap-2
              tw-tracking-tight
              tw-text-lg
              tw-leading-none
              tw-bottom-[0]
              tw-text-center
              tw-align-top
              tw-pt-2
              tw-rounded-b-md
              tw-text-gray-300
            "
            (click)="$event.stopPropagation()"
          >
            <p class="tw-font-normal">
              <span class="tw-font-normal">{{ cavity.cavity }}</span>
            </p>
            <p>
              <span class="tw-font-normal">{{ item.name }}</span>
            </p>
            <p>
              Position: <span class="tw-font-normal">{{ item.position }}</span>
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
